/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/ski-lessons.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/ski-lessons.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/ski-lessons.mdx';

const metadata = {
  slug: "ski-lessons",
  title: "Ski Lessons",
  author: "Christian Battaglia",
  description: "Everything I learned on the slopes applies off the mountain too. A bullet-point brain dump of ski tips, life lessons, and the wisdom of knowing when to quit while you're ahead.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2018-12-26T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["skiing","life lessons","winter sports","personal growth","learning","outdoors","mindfulness","fitness"],
};

export const Route = createFileRoute('/blog/posts/ski-lessons')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/ski-lessons',
    image: '/og/blog/ski-lessons.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
